module.exports = __webpack_public_path__ + "img/prioritas.bc76c8f5.webp";